// src/components/common/table/StandardPagination.tsx

import React, { useMemo } from 'react';
import { Box, Pagination } from '@mui/material';

export type StandardPaginationProps = {
  page: number;
  pageSize: number;
  totalCount: number;
  onChangePage: (page: number) => void;

  size?: 'small' | 'medium';
  shape?: 'rounded' | 'circular';
};

export const StandardPagination: React.FC<StandardPaginationProps> = ({
  page,
  pageSize,
  totalCount,
  onChangePage,
  size = 'medium',
  shape = 'rounded',
}) => {
  const safePageSize = Math.max(1, pageSize);
  const totalPages = useMemo(
    () => Math.max(1, Math.ceil((totalCount ?? 0) / safePageSize)),
    [safePageSize, totalCount],
  );

  return (
    <Box display="flex" justifyContent="center">
      <Pagination
        count={totalPages}
        page={page}
        onChange={(_, next) => onChangePage(next)}
        color="primary"
        size={size}
        shape={shape}
      />
    </Box>
  );
};
